import { SyntheticEvent, useCallback, useState } from 'react'
import DialogButton from '../../../Common/Buttons/DialogButton'
import Dialog from '../../../Common/Dialog/Dialog'
import DialogActions from '../../../Common/Dialog/DialogActions'
import DialogContent from '../../../Common/Dialog/DialogContent'
import DialogTitle from '../../../Common/Dialog/DialogTitle'
import { type UserProductDesignStore } from '../../../UserData/_stores/UserProductDesignStore'
import { DeletePaginationItem } from '../../../UserData/_actions/UserDataActions'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../Common/_hooks/useAppDispatch'
import { StoreProductStore } from '../../../UserData/_stores/Store/StoreProductStore'
import { Alert, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material'
import { useAppSelector } from '../../../Common/_hooks/useAppSelector'
import { UnsyncAllStoreVariants } from '../../../UserData/_actions/Store/StoreVariantActions'

interface Props {
  storeProduct: StoreProductStore
  opened: boolean
  onClose: () => void
}

export default function UnsyncStoreProductDialog(props: Props) {
  const [t] = useTranslation('account-v2')
  const dispatch = useAppDispatch()

  const storeType = useAppSelector(state => state.get('userData').get('stores').get(props.storeProduct.get('id_store'))?.get('slug') ?? '')
  const storeName = useAppSelector(state => state.get('userData').get('stores').get(props.storeProduct.get('id_store'))?.get('name') ?? '')

  const onConfirm = useCallback(() => {
      dispatch(UnsyncAllStoreVariants(storeType, props.storeProduct.get('id')).set({
        onSuccess: () => props.onClose()
      }))
    }, [storeType, props.storeProduct.get('id'), props.onClose])

  return <Dialog
    open={props.opened}
    maxWidth="xs"
    fullWidth
    onClose={props.onClose}
    showCloseButton
  >
    <DialogTitle>{t('Unsync all variants of: {{name}}', { name: props.storeProduct.get('title') })}</DialogTitle>
    <DialogContent>
      <Stack spacing={2}>
        <Typography variant="body1">{t('This will unsync the product from Art of Where.')}</Typography>
        <Alert
          severity="info"
        >{t('If you never want this product to be imported in future orders, you should instead use the "Ignore" feature.')}</Alert>
      </Stack>
    </DialogContent>
    <DialogActions>
      <DialogButton
        color="secondary"
        onClick={props.onClose}
      >{t('Cancel')}</DialogButton>
      <DialogButton
        color="primary"
        onClick={onConfirm}
        autoFocus
      >{t('Unsync')}</DialogButton>
    </DialogActions>
  </Dialog>
}
